/* eslint-disable no-underscore-dangle */
import catchify from 'catchify';

export default (context, inject) => {
  const { $axios, store } = context;

  // Send current list of activities to api, clear activities
  const processActivities = async () => {
    const { __activity = {} } = store.state; // Destructed instead of using lodash
    const { __activityLogs = [] } = __activity;

    // Just in case it gets overridden with another type
    if (!__activityLogs || !Array.isArray(__activityLogs)) {
      store.commit('__activity/reset');
      return;
    }

    try {
      store.commit('__activity/reset');

      if (!__activityLogs || !__activityLogs.length) return;

      const [err] = await catchify(await $axios({
        method: 'post',
        url: '/api/activity/batch/', // Subject to change
        headers: {
          'Content-Type': 'application/json',
        },
        data: __activityLogs,
      }));

      if (err) {
        // eslint-disable-next-line
        console.log('Error Logging Activities:', err);
      }
    } catch (err) {
      store.commit('__activity/reset'); // Something went wrong, start over
      // eslint-disable-next-line
      console.log('Error Parsing Activities:', err);
    }
  };

  // Add an activity
  const add = (a) => {
    const { __activity = {} } = store.state; // Destructed instead of using lodash
    const { __activityLogInterval } = __activity;

    if (!__activityLogInterval) {
      const intervalId = setInterval(processActivities, 1000);
      store.commit('__activity/interval', intervalId);
    }

    // Add timestamp
    if (!a.time) {
      a.time = new Date().toISOString(); // eslint-disable-line no-param-reassign
    }

    const activityLog = {
      ...a,
    };

    store.commit('__activity/add', activityLog);
  };

  // Remove all activities
  const reset = () => {
    store.commit('__activity/reset');
  };

  const activity = {
    add,
    reset,
  };

  inject('activity', activity);
  context.$activity = activity;
};
